module.exports = __webpack_public_path__ + "img/ico-pinterest.7fc796d.svg";